module.exports = __webpack_public_path__ + "img/tag4.ebfa867f.png";